import { Button } from '@/components/ui';
import { cn } from '@/utils/cn';

interface UserDetailTabsProps {
 activeTab: string;
 onTabChange: (tab: string) => void;
}

export function UserDetailTabs({ activeTab, onTabChange }: UserDetailTabsProps) {
 const tabs = [
 { id: 'general', label: 'Thông tin chung' },
 { id: 'profile', label: 'Hồ sơ' },
 { id: 'history', label: 'Lịch sử công tác' },
 { id: 'contracts', label: 'Hợp đồng' },
 { id: 'projects', label: 'Dự án' },
 { id: 'salary', label: 'Lương & Đơn giá' },
 { id: 'documents', label: 'Tài liệu' },
 ];

 return (
 <div className="flex gap-8 border-b border-slate-100 mb-6 overflow-x-auto scrollbar-hide">
 {tabs.map(tab => (
 <Button
 key={tab.id}
 variant="ghost"
 onClick={() => onTabChange(tab.id)}
 className={cn("pb-4 h-auto px-0 rounded-none sm:text-sm text-xs tracking-wider whitespace-nowrap transition-all border-b-2",
 activeTab === tab.id 
 ?"text-emerald-600 border-emerald-700" 
 :"text-slate-400 border-transparent hover:text-slate-600"
 )}
 >
 {tab.label}
 </Button>
 ))}
 </div>
 );
}
